module.exports = __webpack_public_path__ + "static/media/iphone6-3up-blank.9b1bbd0e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/smartphone/iphone6/iphone6-3up-blank.pdf
// module id = 38
// module chunks = 0